import { getExperimentNamePerTenant } from 'shared/experiments/components/PreQuerySuggestionsExtended/helpers'
import {
  SEARCH_BOX_CLEAN_HISTORY_CLICK,
  SEARCH_BOX_QUERY_HISTORY_CLICK,
  SEARCH_BOX_QUERY_SUGGESTION_CLICK,
  SEARCH_BOX_SUGGESTED_BRAND_CLICK,
  SEARCH_BOX_SUGGESTED_CATEGORY_CLICK,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { EXCLUDED_PAGE_TYPES } from 'views/components/organisms/PreQuerySuggestions/consts'

export default () => {
  const { pageType } =
    store.getState()?.publicRuntimeConfig.pageProperties || {}

  const { tenant, deviceClass } =
    store.getState()?.publicRuntimeConfig.publicConfig || {}

  const serpPreQuerySuggestionExperimentName = getExperimentNamePerTenant(
    tenant,
    deviceClass
  )

  const serpPreQuerySuggestionExperiment = getExperimentOnClient(
    serpPreQuerySuggestionExperimentName
  )

  if (
    !serpPreQuerySuggestionExperiment.isEnabled ||
    EXCLUDED_PAGE_TYPES.includes(pageType)
  )
    return

  void activateExperiment(serpPreQuerySuggestionExperimentName)

  const preQueryWrapper = document.querySelector(
    '.o-PreQuerySuggestLayer__wrapper'
  )
  const mobilePreQueryWrapper = document.querySelector(
    '[data-clientside-hook~="SearchBoxMobileContainer"]'
  )

  const trackEvents = (event: Event) => {
    const target = <HTMLElement>event.target

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink_PQ"]')) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
    }
    if (target.closest('[data-clientside-hook~="SearchBoxListSuggestLink"]')) {
      trackOptimizelyEvent(SEARCH_BOX_QUERY_SUGGESTION_CLICK)
    }
    if (target.closest('[data-qa-id="form-searchistory-delete"]')) {
      trackOptimizelyEvent(SEARCH_BOX_CLEAN_HISTORY_CLICK)
    }
    if (target.closest('[data-clientside-hook~="SearchBoxListHistoryLink"]')) {
      trackOptimizelyEvent(SEARCH_BOX_QUERY_HISTORY_CLICK)
    }
    if (
      target.closest('[data-clientside-hook~="SearchBoxListSuggestBrandLink"]')
    ) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_BRAND_CLICK)
    }
    if (
      target.closest(
        '[data-clientside-hook~="SearchBoxListSuggestCategoryLink"]'
      )
    ) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_CATEGORY_CLICK)
    }
  }

  preQueryWrapper?.addEventListener('click', trackEvents)
  mobilePreQueryWrapper?.addEventListener('click', trackEvents)
}
